import React from 'react';


const CallsContent = (props: any) => {
    return <>calls content coming soon!</>
}

export default CallsContent;